import { templateParseToElement } from "../../logic/templateParse.js";
import { BonusParametersComponent } from "../bonus-parameters/bonus-parameters.js";
import { DataBaseComponent } from "./data-base-component.js";

export class DataBonusParamComponent extends DataBaseComponent {
    static webComponentName: string = "data-bonusparam";
    protected _templateId: string = "data-bonusparam-component"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for ambito fields
    protected bonusParametersComponent:BonusParametersComponent|null=null; // Reference to the bonus parameters component
    protected rendered: boolean = false; 
    constructor() {
        super();
    }
    protected setupSyncEventListeners(): void {} // No sync events needed
    // [codex] begin: accessor value allineato al child <bonus-parameters>
    // Getter: ritorna sempre il valore corrente calcolato dal DOM del componente figlio
    // Setter: delega al setter base per mantenere il comportamento di DataBaseComponent
    //         e innescare onChangeValue/onSetValue, evitando errori di sola-lettura a runtime
    get value(): any {
        if (this.bonusParametersComponent && this.rendered) {
            console.log(`DataBonusParamComponent: getting value from bonusParametersComponent`, 
                this.bonusParametersComponent.value , super.value);
            return this.bonusParametersComponent.value;
        }
        return super.value;
    }
    set value(newValue: any) {
        console.log(`DataBonusParamComponent: setting value`, newValue);
        super.value = newValue;
    }
    // [codex] end
   
   
    addDataForTemplate(): Record<string, any> {
        // const initialValue = Array.isArray(this.value) ? this.value.join(', ') : '';
        const initialValue = this.value ?? null;
        return {
            inputType: this.inputType, // Pass the input type to the template
            field:this.field, // Include field metadata
            readonly: this.readOnly, // Pass readOnly state
            initialValue
        };
    }
    protected afterRender(): void {
        this.bonusParametersComponent = this.querySelector<BonusParametersComponent>('bonus-parameters');
        if(this.bonusParametersComponent) {
            this.bonusParametersComponent.inputValueRaw = this.value;
            this.rendered = true;
        }
    }
    // [codex] begin: propagazione valore in ingresso verso il child
    // protected onChangeValue(newValue: any): void {
    //     if (this.bonusParametersComponent) {
            
    //         this.bonusParametersComponent.inputValueRaw = newValue;
    //     }
    // }
    // [codex] end
    protected render(): void {
        templateParseToElement(this.templateId, this,this.addDataForTemplate());
        this.afterRender();
    }
}
